module.exports = __webpack_public_path__ + "d321ae94b51e7c52901ffe0f9f16f3b0.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/above-the-fold-new-bg2.png
// module id = ./app/images/above-the-fold-new-bg2.png
// module chunks = 29